module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55c33826","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/oauth/key.vue
// module id = 766
// module chunks = 2